import { render } from "./StartGamePopup.vue?vue&type=template&id=020e9b41&scoped=true"
import script from "./StartGamePopup.vue?vue&type=script&lang=ts"
export * from "./StartGamePopup.vue?vue&type=script&lang=ts"

import "./StartGamePopup.vue?vue&type=style&index=0&id=020e9b41&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-020e9b41"

export default script